const INITIAL_PROGRAM_LICENSES = {
  loading: true,
  error: null,
  result: [],
  resultNew: [],
};

export const FETCH_PROGRAM_LICENSES_BEGIN = "FETCH_PROGRAM_LICENSES_BEGIN";
export const FETCH_PROGRAM_LICENSES_FULFILLED =
  "FETCH_PROGRAM_LICENSES_FULFILLED";
export const FETCH_PROGRAM_LICENSES_REJECTED =
  "FETCH_PROGRAM_LICENSES_REJECTED";

export const FETCH_PROGRAM_LICENSES_BY_CUSTOMER_BEGIN =
  "FETCH_PROGRAM_LICENSES_BY_CUSTOMER_BEGIN";
export const FETCH_PROGRAM_LICENSES_BY_CUSTOMER_FULFILLED =
  "FETCH_PROGRAM_LICENSES_BY_CUSTOMER_FULFILLED";
export const FETCH_PROGRAM_LICENSES_BY_CUSTOMER_REJECTED =
  "FETCH_PROGRAM_LICENSES_BY_CUSTOMER_REJECTED";
export const FETCH_PROGRAM_LICENSES_BY_CUSTOMER_NEW_BEGIN =
  "FETCH_PROGRAM_LICENSES_BY_CUSTOMER_NEW_BEGIN";
export const FETCH_PROGRAM_LICENSES_BY_CUSTOMER_NEW_FULFILLED =
  "FETCH_PROGRAM_LICENSES_BY_CUSTOMER_NEW_BEGIN";
export const FETCH_PROGRAM_LICENSES_BY_CUSTOMER_NEW_REJECTED =
  "FETCH_PROGRAM_LICENSES_BY_CUSTOMER_NEW_BEGIN";

export function programLicenseReducer(
  state = INITIAL_PROGRAM_LICENSES,
  action = {}
) {
  switch (action.type) {
    case FETCH_PROGRAM_LICENSES_BEGIN: {
      return { ...state, loading: true, error: null };
    }
    case FETCH_PROGRAM_LICENSES_FULFILLED: {
      return { ...state, loading: false, error: null, result: action.payload };
    }
    case FETCH_PROGRAM_LICENSES_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    }
    default: {
      return { ...state };
    }
  }
}

const INITIAL_PROGRAM_LICENSES_BY_CUSTOMER = {
  loading: true,
  error: null,
  result: [],
};
export function programLicenseByCustomerReducer(
  state = INITIAL_PROGRAM_LICENSES_BY_CUSTOMER,
  action = {}
) {
  switch (action.type) {
    case FETCH_PROGRAM_LICENSES_BY_CUSTOMER_BEGIN: {
      return { ...state, loading: true, error: null };
    }
    case FETCH_PROGRAM_LICENSES_BY_CUSTOMER_FULFILLED: {
      return { ...state, loading: false, error: null, result: action.payload };
    }
    case FETCH_PROGRAM_LICENSES_BY_CUSTOMER_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    }
    default: {
      return { ...state };
    }
  }
}
